import { Widget, WidgetSettingType } from '../base/widget/WidgetInterface'
import { WidgetHeightType, WidgetType } from '../base/widget/WidgetTypes'

export const predefinedColumns = ['name', 'updated', 'note', 'vehicle']

export const WidgetStatusDetail: Widget = {
  type: WidgetType.statusDetail,
  noPadding: true,
  title: 'Personalansicht',
  minSize: 2,
  defaultSize: 8,
  icon: 'AccountMultiple',
  defaultHeightType: WidgetHeightType.automatic,
  customSettings: {
    settings: {
      showStatusNames: { type: WidgetSettingType.checkbox, title: 'Statusnamen anzeigen', checked: false },
      showFullTime: { type: WidgetSettingType.checkbox, title: 'Vollständige Uhrzeit anzeigen', checked: false },

      paddingVerticalRows: { type: WidgetSettingType.number, title: 'Vertikaler Zeilenabstand', value: 4, min: 4, max: 32 },
      dynamicWidthColumnsQualifications: { type: WidgetSettingType.checkbox, title: 'Dynamische Spaltenbreite, Qualifikationen', checked: true },
      widthColumnsQualifications: { type: WidgetSettingType.number, title: 'Spaltenbreite, Qualifikationen', value: 48, min: 48, max: 256 },

      dynamicWidthColumnsName: { type: WidgetSettingType.checkbox, title: 'Dynamische Spaltenbreite, Name', checked: true },
      widthColumnsName: { type: WidgetSettingType.number, title: 'Spaltenbreite, Name', value: 256, min: 48, max: 1024 },

      dynamicWidthColumnsUpdated: { type: WidgetSettingType.checkbox, title: 'Dynamische Spaltenbreite, Aktualisiert', checked: true },
      widthColumnsUpdated: { type: WidgetSettingType.number, title: 'Spaltenbreite, Aktualisiert', value: 128, min: 48, max: 1024 },

      dynamicWidthColumnsVehicles: { type: WidgetSettingType.checkbox, title: 'Dynamische Spaltenbreite, Fahrzeuge', checked: true },
      widthColumnsVehicles: { type: WidgetSettingType.number, title: 'Spaltenbreite, Fahrzeuge', value: 128, min: 48, max: 1024 },

      dynamicWidthColumnsNotes: { type: WidgetSettingType.checkbox, title: 'Dynamische Spaltenbreite, Notiz', checked: true },
      widthColumnsNotes: { type: WidgetSettingType.number, title: 'Spaltenbreite, Notiz', value: 128, min: 48, max: 1024 },

      fontSizeStatusNames: { type: WidgetSettingType.number, title: 'Schriftgröße, Statusnamen', value: 18, min: 14, max: 128 },
      fontSizeTable: { type: WidgetSettingType.number, title: 'Schriftgröße, Tabelle', value: 16, min: 14, max: 128 },
      fontBoldTable: { type: WidgetSettingType.checkbox, title: 'Schriftdicke fett, Tabelle', checked: false },

      sortUnits: { type: WidgetSettingType.selectbox, title: 'Sortierung des Personals', value: '3', options: [
          { label: 'Vorname (absteigend, A-Z)', value: 1 },
          { label: 'Nachname (absteigend, A-Z)', value: 2 },
          { label: 'Letzte Aktualisierung (absteigend)', value: 3 }
      ]},
      sortStatus: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomStatusSorting' },
      sortStatusColumns: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomCustomStatusColumnsSorting' },

      selectedGroup: { type: WidgetSettingType.custom, data: {}, template: 'custom/SettingsPanelCustomGroupSelect' },
      showGroupName: { type: WidgetSettingType.checkbox, title: 'Gruppenname anzeigen', checked: false }
    },
    sections: [
      {
        label: 'Schriftgrößen',
        settings: [
          'fontSizeStatusNames',
          'fontSizeTable',
          'fontBoldTable'
        ]
      },
      {
        label: 'Gruppenfilter',
        settings: [
          'selectedGroup',
          'showGroupName'
        ]
      },
      {
        label: 'Filter (sortierbar)',
        settings: [
          'sortUnits',
          'sortStatus',
          'sortStatusColumns'
        ]
      },
      {
        label: 'Dimensionen',
        settings: [
          'paddingVerticalRows',
          'dynamicWidthColumnsName',
          'widthColumnsName',
          'dynamicWidthColumnsUpdated',
          'widthColumnsUpdated',
          'dynamicWidthColumnsVehicles',
          'widthColumnsVehicles',
          'dynamicWidthColumnsNotes',
          'widthColumnsNotes',
          'dynamicWidthColumnsQualifications',
          'widthColumnsQualifications'
        ]
      }
    ]
  }
}

export default WidgetStatusDetail
